 <template>
    <div class="maskbg">
        <div class="dialog gwyg">
            <div class="close" @click="handleClose"></div>
            <div class="flx-bs">
                <div class="left">
                    <div class="main">
                        <div class="video" v-for="(item,index) in info.video" :key="index">
                            <video v-if="item.url" :src="item.url" controls></video>
                            <span v-else>暂无视频</span>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="main">
                        <div class="flx user" v-for="(item,index) in info.users" :key="index">
                            <div class="image"><img :src="item.photo" /></div>
                            <div class="info">
                                <div class="status">{{item.status}}</div>
                                <div class="intro" @click="infoShow=true;data=item.info">{{item.info}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Info v-if="infoShow" :visible.sync="infoShow" :info="data"></Info>
    </div>
</template>

<script>
import axios from 'axios'
import Info from './info.vue'
export default {
    components: {Info},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            infoShow: false,
            data: ''
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        handleClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/dialog';
</style>